export enum NavTypesEnum {
  MENU = 'MENU',
  PROJECT = 'PROJECT',
  ITEM = 'ITEM',
}
